import { BadgeCheck, Eye, Lock, ShieldAlert } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: BadgeCheck, title: "Verified pros", sub: "Submit a license or work ID" },
  { icon: ShieldAlert, title: "Report & Block", sub: "On every profile and chat" },
  { icon: Eye, title: "24h moderation", sub: "Every report is reviewed" },
  { icon: Lock, title: "Privacy first", sub: "You control what you share" },
];

export const TrustStrip = () => (
  <section data-testid="trust-strip" className="bg-espresso text-white">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-8 px-5 py-10 sm:px-8 lg:grid-cols-4">
      {ITEMS.map((it, i) => (
        <Reveal key={it.title} delay={i * 0.08}>
          <div data-testid={`trust-item-${i}`} className="flex flex-col items-center gap-2 text-center">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/10 text-sage">
              <it.icon size={20} />
            </span>
            <div className="text-sm font-extrabold">{it.title}</div>
            <div className="text-xs text-white/60">{it.sub}</div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
